import React, { useEffect } from 'react';
import { City } from './types';
import { Cities } from './Cities';
import { CityNav } from './CityNav';

export type CityListProps = {
  cities: (City & { name: string; slug: string; cityJobsPageUrl: string })[];
  seeMoreText: string;
  seeAllText: string;
  title: string;
};

export const CityList = ({ cities, seeMoreText, seeAllText, title }: CityListProps) => {
  return (
    <div className="state-jobs lg:max-w-7xl px-7 xl:px-0 m-auto py-10 lg:pb-24 lg:pt-32 text-kale">
      <h1 className="font-heading text-hxl lg:text-h2xl mb-4">{title}</h1>
      <CityNav cities={cities} />
      <div
        className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-2"
      >
        {cities.map((city, index) => {
          return <Cities key={index} city={city} seeAllText={seeAllText} />;
        })}
      </div>
    </div>
  );
};
